/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateTimerecordHolidayDto } from '../models/work-create-timerecord-holiday-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkTimerecordHoliday } from '../models/work-timerecord-holiday';
import { WorkUniqueHolidayDto } from '../models/work-unique-holiday-dto';
import { WorkUpdateTimerecordHolidayDto } from '../models/work-update-timerecord-holiday-dto';

@Injectable({ providedIn: 'root' })
export class WorkTimerecordHolidaysV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `timerecordHolidaysV2ControllerFindAllPaginated()` */
  static readonly TimerecordHolidaysV2ControllerFindAllPaginatedPath = '/v2/timerecord-holidays';

  /**
   * Required permissions: timerecords:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordHolidaysV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordHolidaysV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 500
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessunitId=$not:$like:John Doe&filter.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessunitId'?: Array<string>;

    /**
     * Filter by businessdivisionId query param.
     *           <p>
     *              <b>Format: </b> filter.businessdivisionId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessdivisionId=$not:$like:John Doe&filter.businessdivisionId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessdivisionId'?: Array<string>;

    /**
     * Filter by timerecordtypeId query param.
     *           <p>
     *              <b>Format: </b> filter.timerecordtypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.timerecordtypeId=$not:$like:John Doe&filter.timerecordtypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.timerecordtypeId'?: Array<string>;

    /**
     * Filter by locationId query param.
     *           <p>
     *              <b>Format: </b> filter.locationId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.locationId=$not:$like:John Doe&filter.locationId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.locationId'?: Array<string>;

    /**
     * Filter by date query param.
     *           <p>
     *              <b>Format: </b> filter.date={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.date=$not:$like:John Doe&filter.date=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$lte</li>
     * <li>$gte</li></ul>
     */
      'filter.date'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> date:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>description</li>
     * <li>date</li>
     * <li>timerecordtypeId</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'description:ASC' | 'description:DESC' | 'date:ASC' | 'date:DESC' | 'timerecordtypeId:ASC' | 'timerecordtypeId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,date,businessunit.name,businessdivision.name,location.name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>date</li>
     * <li>businessunit.name</li>
     * <li>businessdivision.name</li>
     * <li>location.name</li>
     * <li>timerecordtype.name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTimerecordHoliday>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'timerecordtypeId'?: (string | Array<string>);
'locationId'?: (string | Array<string>);
'date'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordHolidaysV2Service.TimerecordHolidaysV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.businessunitId', params['filter.businessunitId'], {});
      rb.query('filter.businessdivisionId', params['filter.businessdivisionId'], {});
      rb.query('filter.timerecordtypeId', params['filter.timerecordtypeId'], {});
      rb.query('filter.locationId', params['filter.locationId'], {});
      rb.query('filter.date', params['filter.date'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkTimerecordHoliday>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'businessunitId'?: (string | Array<string>);
        'businessdivisionId'?: (string | Array<string>);
        'timerecordtypeId'?: (string | Array<string>);
        'locationId'?: (string | Array<string>);
        'date'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: timerecords:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordHolidaysV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordHolidaysV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 500
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessunitId=$not:$like:John Doe&filter.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessunitId'?: Array<string>;

    /**
     * Filter by businessdivisionId query param.
     *           <p>
     *              <b>Format: </b> filter.businessdivisionId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessdivisionId=$not:$like:John Doe&filter.businessdivisionId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.businessdivisionId'?: Array<string>;

    /**
     * Filter by timerecordtypeId query param.
     *           <p>
     *              <b>Format: </b> filter.timerecordtypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.timerecordtypeId=$not:$like:John Doe&filter.timerecordtypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.timerecordtypeId'?: Array<string>;

    /**
     * Filter by locationId query param.
     *           <p>
     *              <b>Format: </b> filter.locationId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.locationId=$not:$like:John Doe&filter.locationId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.locationId'?: Array<string>;

    /**
     * Filter by date query param.
     *           <p>
     *              <b>Format: </b> filter.date={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.date=$not:$like:John Doe&filter.date=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$lte</li>
     * <li>$gte</li></ul>
     */
      'filter.date'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> date:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>description</li>
     * <li>date</li>
     * <li>timerecordtypeId</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'description:ASC' | 'description:DESC' | 'date:ASC' | 'date:DESC' | 'timerecordtypeId:ASC' | 'timerecordtypeId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,date,businessunit.name,businessdivision.name,location.name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>date</li>
     * <li>businessunit.name</li>
     * <li>businessdivision.name</li>
     * <li>location.name</li>
     * <li>timerecordtype.name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkTimerecordHoliday>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'timerecordtypeId'?: (string | Array<string>);
'locationId'?: (string | Array<string>);
'date'?: (string | Array<string>);
};
};
}> {
    return this.timerecordHolidaysV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTimerecordHoliday>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'timerecordtypeId'?: (string | Array<string>);
'locationId'?: (string | Array<string>);
'date'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkTimerecordHoliday>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'businessunitId'?: (string | Array<string>);
'businessdivisionId'?: (string | Array<string>);
'timerecordtypeId'?: (string | Array<string>);
'locationId'?: (string | Array<string>);
'date'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `timerecordHolidaysV2ControllerCreate()` */
  static readonly TimerecordHolidaysV2ControllerCreatePath = '/v2/timerecord-holidays';

  /**
   * Required permissions: timerecords:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordHolidaysV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecordHolidaysV2ControllerCreate$Response(
    params: {
      body: WorkCreateTimerecordHolidayDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimerecordHoliday>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordHolidaysV2Service.TimerecordHolidaysV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimerecordHoliday>;
      })
    );
  }

  /**
   * Required permissions: timerecords:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordHolidaysV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecordHolidaysV2ControllerCreate(
    params: {
      body: WorkCreateTimerecordHolidayDto
    },
    context?: HttpContext
  ): Observable<WorkTimerecordHoliday> {
    return this.timerecordHolidaysV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimerecordHoliday>): WorkTimerecordHoliday => r.body)
    );
  }

  /** Path part for operation `timerecordHolidaysV2ControllerFindUniqueByDateRange()` */
  static readonly TimerecordHolidaysV2ControllerFindUniqueByDateRangePath = '/v2/timerecord-holidays/unique';

  /**
   * Required permissions: timerecords:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordHolidaysV2ControllerFindUniqueByDateRange()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordHolidaysV2ControllerFindUniqueByDateRange$Response(
    params: {
      dateFrom: string;
      dateTo: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkUniqueHolidayDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordHolidaysV2Service.TimerecordHolidaysV2ControllerFindUniqueByDateRangePath, 'get');
    if (params) {
      rb.query('dateFrom', params.dateFrom, {});
      rb.query('dateTo', params.dateTo, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkUniqueHolidayDto>>;
      })
    );
  }

  /**
   * Required permissions: timerecords:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordHolidaysV2ControllerFindUniqueByDateRange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordHolidaysV2ControllerFindUniqueByDateRange(
    params: {
      dateFrom: string;
      dateTo: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkUniqueHolidayDto>> {
    return this.timerecordHolidaysV2ControllerFindUniqueByDateRange$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkUniqueHolidayDto>>): Array<WorkUniqueHolidayDto> => r.body)
    );
  }

  /** Path part for operation `timerecordHolidaysV2ControllerFindOneById()` */
  static readonly TimerecordHolidaysV2ControllerFindOneByIdPath = '/v2/timerecord-holidays/{id}';

  /**
   * Required permissions: timerecords:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordHolidaysV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordHolidaysV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimerecordHoliday>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordHolidaysV2Service.TimerecordHolidaysV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimerecordHoliday>;
      })
    );
  }

  /**
   * Required permissions: timerecords:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordHolidaysV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordHolidaysV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTimerecordHoliday> {
    return this.timerecordHolidaysV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimerecordHoliday>): WorkTimerecordHoliday => r.body)
    );
  }

  /** Path part for operation `timerecordHolidaysV2ControllerDelete()` */
  static readonly TimerecordHolidaysV2ControllerDeletePath = '/v2/timerecord-holidays/{id}';

  /**
   * Required permissions: timerecords:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordHolidaysV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordHolidaysV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordHolidaysV2Service.TimerecordHolidaysV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: timerecords:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordHolidaysV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordHolidaysV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.timerecordHolidaysV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `timerecordHolidaysV2ControllerUpdate()` */
  static readonly TimerecordHolidaysV2ControllerUpdatePath = '/v2/timerecord-holidays/{id}';

  /**
   * Required permissions: timerecords:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordHolidaysV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecordHolidaysV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateTimerecordHolidayDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimerecordHoliday>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordHolidaysV2Service.TimerecordHolidaysV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimerecordHoliday>;
      })
    );
  }

  /**
   * Required permissions: timerecords:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordHolidaysV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecordHolidaysV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateTimerecordHolidayDto
    },
    context?: HttpContext
  ): Observable<WorkTimerecordHoliday> {
    return this.timerecordHolidaysV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimerecordHoliday>): WorkTimerecordHoliday => r.body)
    );
  }

  /** Path part for operation `timerecordHolidaysV2ControllerFindByDateRange()` */
  static readonly TimerecordHolidaysV2ControllerFindByDateRangePath = '/v2/timerecord-holidays/byDate/{dateFrom}/{dateTo}';

  /**
   * Required permissions: timerecords:read, timerecords:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordHolidaysV2ControllerFindByDateRange()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordHolidaysV2ControllerFindByDateRange$Response(
    params: {
      dateFrom: string;
      dateTo: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTimerecordHoliday>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordHolidaysV2Service.TimerecordHolidaysV2ControllerFindByDateRangePath, 'get');
    if (params) {
      rb.path('dateFrom', params.dateFrom, {});
      rb.path('dateTo', params.dateTo, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTimerecordHoliday>>;
      })
    );
  }

  /**
   * Required permissions: timerecords:read, timerecords:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordHolidaysV2ControllerFindByDateRange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordHolidaysV2ControllerFindByDateRange(
    params: {
      dateFrom: string;
      dateTo: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkTimerecordHoliday>> {
    return this.timerecordHolidaysV2ControllerFindByDateRange$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTimerecordHoliday>>): Array<WorkTimerecordHoliday> => r.body)
    );
  }

}
